import ua from 'universal-analytics';

const visitor = ua('UA-99799566-2', { https: true });

export default {
	actions: {
		sendEvent(context, payload) {
			visitor.event(payload).send();
		},
	},
};



// WEBPACK FOOTER //
// ./src/store/analytics.js